import { paymentProviderLabel } from '@cartiq/shared';
import type { PaymentProvider } from '../types';

interface Props {
  url: string;
  total?: string;
  provider?: PaymentProvider;
}

/**
 * `paymentProviderLabel` is typed for the merchant-routable providers; the WS
 * reply may also carry `xendit`, for which the helper safely returns the raw id.
 */
function providerLabel(provider: PaymentProvider): string {
  return paymentProviderLabel(provider as Parameters<typeof paymentProviderLabel>[0]);
}

export function CheckoutCard({ url, total, provider }: Props) {
  return (
    <div
      className="w-full rounded-md border border-border bg-white p-4 shadow-card animate-pop-in"
      style={{ borderLeft: '4px solid var(--color-warning)' }}
    >
      <div className="flex items-center gap-2 text-mid">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="11" width="16" height="9" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
        <span className="text-xs font-semibold uppercase tracking-wide">Secure checkout</span>
      </div>

      <p className="mt-2 text-base font-bold text-primary">Total: {total ?? 'Ready'}</p>
      <p className="mt-0.5 text-xs text-mid">
        You'll be redirected to a secure payment page to complete your order.
      </p>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="group mt-3 flex w-full items-center justify-center gap-1.5 rounded-sm px-4 py-2.5 text-sm font-semibold text-white shadow-[0_4px_14px_rgba(108,99,255,0.3)] transition-all hover:brightness-105 active:scale-[0.98]"
        style={{ backgroundColor: 'var(--brand-accent)' }}
      >
        Pay Now
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-200 group-hover:translate-x-0.5">
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      </a>

      {provider && (
        <p className="mt-2 text-center text-[11px] text-mid">
          You'll pay securely with {providerLabel(provider)}
        </p>
      )}
    </div>
  );
}

export default CheckoutCard;
